module.exports = __webpack_public_path__ + "static/quiz_good-ae0f9e4a0d548ba4353bcb514632166f.jpg";